import { render, staticRenderFns } from "./platform-menu-preview.vue?vue&type=template&id=2f9f72e2&scoped=true"
import script from "./platform-menu-preview.vue?vue&type=script&lang=js"
export * from "./platform-menu-preview.vue?vue&type=script&lang=js"
import style0 from "./platform-menu-preview.vue?vue&type=style&index=0&id=2f9f72e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9f72e2",
  null
  
)

export default component.exports